interface HangmanFigureProps {
  /// 0–6. Each wrong guess reveals one more limb in the order
  /// head → body → left arm → right arm → left leg → right leg.
  wrongs: number;
  /// Pixel width. Height scales 1.4×.
  width?: number;
}

/// Classic gallows + stickman. Gallows is always drawn; limbs appear
/// one at a time as `wrongs` increases from 0 to 6. At 6 the man is
/// fully hung.
export function HangmanFigure({ wrongs, width = 160 }: HangmanFigureProps) {
  const w = width;
  const h = Math.round(width * 1.4);
  // Use a 200×280 viewBox so the limb coordinates below stay readable.
  const stroke = "var(--text, #1c2730)";
  const sw = 4;
  const limbsShown = Math.max(0, Math.min(6, wrongs));

  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 200 280"
      aria-label={`Hangman: ${limbsShown} of 6 wrong guesses`}
      role="img"
    >
      {/* Gallows base, post, beam, rope */}
      <g stroke={stroke} strokeWidth={sw} strokeLinecap="round" fill="none">
        <line x1="20" y1="270" x2="120" y2="270" />          {/* base */}
        <line x1="60" y1="270" x2="60" y2="20" />            {/* post */}
        <line x1="60" y1="20" x2="140" y2="20" />            {/* beam */}
        <line x1="140" y1="20" x2="140" y2="50" />           {/* rope */}
      </g>

      {/* Limbs revealed in order */}
      <g stroke={stroke} strokeWidth={sw} strokeLinecap="round" fill="none">
        {limbsShown >= 1 && (
          <circle cx="140" cy="70" r="20" />                 /* head */
        )}
        {limbsShown >= 2 && (
          <line x1="140" y1="90" x2="140" y2="170" />        /* body */
        )}
        {limbsShown >= 3 && (
          <line x1="140" y1="115" x2="115" y2="145" />       /* left arm */
        )}
        {limbsShown >= 4 && (
          <line x1="140" y1="115" x2="165" y2="145" />       /* right arm */
        )}
        {limbsShown >= 5 && (
          <line x1="140" y1="170" x2="115" y2="210" />       /* left leg */
        )}
        {limbsShown >= 6 && (
          <line x1="140" y1="170" x2="165" y2="210" />       /* right leg */
        )}
      </g>
    </svg>
  );
}
